/**
 * Tokens de las páginas públicas (landing, precios, centro de ayuda).
 * Mismos valores que LandingPage/PricingPage: crema, tinta y el amarillo de alerta de stock.
 */
export const CREAM = '#F5EFE0';
export const CREAM_SOFT = '#FAF6EC';
export const INK = '#0A0A0A';
export const YELLOW = '#F6D058';
export const YELLOW_DEEP = '#E8B923';
export const INDIGO = '#1e40af';
export const RULE = 'rgba(10,10,10,0.12)';
export const RULE_HARD = 'rgba(10,10,10,0.22)';
export const INK_MUTED = 'rgba(10,10,10,0.62)';

export const DISPLAY = '"Instrument Serif", "Times New Roman", Georgia, serif';
export const SANS = '"Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif';
export const MONO = '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace';

/** Línea de ventas (la 2669) que atiende el bot de sales-hub. */
export const SALES_WHATSAPP = '5491126693551';
export const whatsappLink = (text = 'Hola! Vengo de la web de DashFlow y quiero saber cómo funciona') =>
  `https://wa.me/${SALES_WHATSAPP}?text=${encodeURIComponent(text)}`;
